<!--  -->
<template>
  <EDialog
    dialog-title="原材料订单"
    :center-dialog-visible="dialogVisible"
    popup-width="520px"
    show-close-btn
    :show-btn="false"
    @resetPopupData="onCancel"
  >
    <div class="order-no">
      <template v-for="(item, index) in purchaseList">
        <eui-btn :key="index" type="link" font-size="12px" @click.native.prevent="goToDetail(item)">
          {{ item.stockNo || item.orderNo }}
        </eui-btn>
      </template>
    </div>
  </EDialog>
</template>

<script>
import EDialog from '@/modules/projectA/components/common/e-dialog.vue';
import { epecMallUrl } from '@/modules/projectA/api/config';

export default {
  components: {
    EDialog,
  },
  props: {
    visible: Boolean,
    purchaseList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
  },

  methods: {
    onCancel() {
      this.dialogVisible = false;
    },
    goToDetail(row) {
      const {stockId, orderId} = row;
      if (orderId) {
        window.open(
                `${epecMallUrl}/materialPurchasingOrder?orderId=${orderId}&orderFlag=orderDetail&flag=canHandle`,
          '_blank'
        );
      } else {
        this.$router.push({
          name: 'StockDetail',
          params: {
            id: stockId,
          },
        });
      }

    },
  },
};
</script>
<style lang="scss" scoped>
.order-no {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: auto;
}

::v-deep .btn_eui + .btn_eui {
  margin-left: 0;
}
</style>
